var Cells = /** @class */ (function () {
    function Cells() {
        this.cells = {};
    }
    Cells.prototype.add = function (id, cell) {
        if (!this.cells.hasOwnProperty(id)) {
            this.cells[id] = {};
        }
        this.cells[id][cell.getName()] = cell;
    };
    Cells.prototype.getByID = function (id) {
        var result = [];
        if (!this.cells.hasOwnProperty(id.toString())) {
            return result;
        }
        var cells = this.cells[id.toString()];
        Object.keys(cells).forEach(function (name) { return result.push(cells[name]); });
        return result;
    };
    Cells.prototype.getAll = function () {
        var _this = this;
        var results = [];
        Object.keys(this.cells).forEach(function (id) {
            var cells = _this.cells[id];
            Object.keys(cells).forEach(function (name) { return results.push(cells[name]); });
        });
        return results;
    };
    Cells.prototype.getByName = function (name) {
        var _this = this;
        var results = [];
        Object.keys(this.cells).forEach(function (id) {
            var cells = _this.cells[id];
            Object.keys(cells).forEach(function (column_name) {
                if (name === column_name) {
                    results.push(cells[column_name]);
                }
            });
        });
        return results;
    };
    Cells.prototype.get = function (id, name) {
        return this.cells.hasOwnProperty(id.toString()) ? this.cells[id][name] : null;
    };
    return Cells;
}());
export default Cells;
